import { useEffect, useRef } from 'react';

const Loader = () => {
  const canvasRef = useRef(null);
  
  class Point {
    constructor(x, y) {
      this.x = x;
      this.y = y;
    }
    static distance(a, b) {
      const dx = a.x - b.x;
      const dy = a.y - b.y;
      return Math.hypot(dx, dy);
      }
    }
    class Node {
    constructor(cx, cy, a, r, s, e, d, b) {
      this.center = new Point(cx, cy);
      this.angle = a;
      this.radius = r;
      this.speed = s;
      this.edgeLength = e;
      this.direction = d; // horizontal or vertical
      this.reverse = b; // clockwise or anti-colockwise
      this.getPosition();
    }
    getPosition() {
      var b = this.reverse ? -1 : 1;
      // horizontal
      if (this.direction) {
        this.position = new Point(
          this.center.x + Math.sin(this.angle) * this.radius,
          this.center.y + b * Math.sin(this.angle * 2) * this.radius * 0.4
        );
      } else {
        // vertical
        this.position = new Point(
          this.center.x + b * Math.sin(this.angle * 2) * this.radius * 0.4,
          this.center.y + Math.sin(this.angle) * this.radius
        );
      }
    }
    update() {
      this.angle += this.speed;
      this.getPosition();
    }
    neighbors(nodes) {
      var edges = [];
      for (var i = 0; i < nodes.length; i++) {
        var d = Point.distance(this.position, nodes[i].position);
        if (d > 0 && d < this.edgeLength) {
          edges.push([this.position, nodes[i].position, d]);
        }
      }
      return edges;
    }
  }

  useEffect(() => {    
      function hexToRGB(hex, alpha) {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        if (alpha) {
          return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
        } else {
          return 'rgb(' + r + ',' + g + ',' + b + ')';
        }
      }
    
      // for retina display
      function getDevicePixelRatio() {
        let ratio = 1;
        if (
          window.screen.systemXDPI &&
          window.screen.logicalXDPI &&
          window.screen.systemXDPI > window.screen.logicalXDPI
        ) {
          ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
        } else if (window.devicePixelRatio) {
          ratio = window.devicePixelRatio;
        }
        return ratio;
      }
    
      // setup canvas
      // var canvas = document.getElementById('canvas');
      const canvas = canvasRef.current;
      var ratio = getDevicePixelRatio();
      var width = 100;
      var height = 100;
      canvas.style.width = 150 + 'px';
      canvas.style.height = 150 + 'px';
      canvas.width = width * ratio;
      canvas.height = height * ratio;
    
      // setup nodes
      var nodes = [];
      var edgeLength = 80;
      var color = '#4f37a9';
      var center = new Point(width / 2, height / 2);
      nodes.push(
      new Node(
        center.x,
        center.y,
        0.5,
        edgeLength * 0.4,
        0.03,
        edgeLength,
        true,
        true
      )
      );
      nodes.push(
      new Node(
        center.x,
        center.y,
        0.5,
        edgeLength * 0.4,
        0.01,
        edgeLength,
        true,
        false
      )
      );
      nodes.push(
      new Node(
        center.x,
        center.y,
        0.5,
        edgeLength * 0.4,
        0.03,
        edgeLength,
        false,
        false
      )
      );
      nodes.push(
      new Node(
        center.x,
        center.y,
        0.5,
        edgeLength * 0.4,
        0.01,
        edgeLength,
        false,
        true
      )
      );
    
      function drawNodes() {
      // setup background
        var ctx = canvas.getContext('2d');
        ctx.save();
        ctx.scale(ratio, ratio);
        ctx.fillStyle = '#FFF';
        ctx.fillRect(0, 0, width, height);
    
      // drawing nodes and lines
      for (let i = 0; i < nodes.length; i++) {
        const one = nodes[i];
        one.update();
        const edges = one.neighbors(nodes);
        for (const e of edges) {
          const alpha = (edgeLength * 0.8 - e[2]) / edgeLength;
          ctx.lineWidth = 1;
          ctx.strokeStyle = hexToRGB(color, alpha);
          ctx.beginPath();
          ctx.moveTo(e[0].x, e[0].y);
          ctx.lineTo(e[1].x, e[1].y);
          ctx.stroke();
          ctx.closePath();
        }
        ctx.beginPath();
        ctx.ellipse(one.position.x, one.position.y, 3, 3, 0, 0, 2 * Math.PI);
        ctx.lineWidth = 0;
        ctx.fillStyle = color;
        ctx.fill();
        ctx.closePath();
      }
      ctx.restore();
      // Schedule next
      window.requestAnimationFrame(drawNodes);
    }
    drawNodes();
    // eslint-disable-next-line
  }, [])

    return <canvas ref={canvasRef} width="100" height="100" />
  }

export default Loader;